import { SubmissionReviewStatuses } from '../constants/submission-review-statuses'

export const computeFirstUnreviewedQuestionRubric = (statsPerQuestionRubric = []) => {
  const target = statsPerQuestionRubric?.find(stat => (stat?.reviewedPercentage ?? 0) < 100)
  return target?.id
}

export const computeNextUnreviewedQuestionRubric = (currentQuestionRubricId, statsPerQuestionRubric = []) => {
  if (!Array.isArray(statsPerQuestionRubric) || statsPerQuestionRubric.length === 0) return undefined
  const currentIndex = statsPerQuestionRubric.findIndex(stat => stat.id === Number(currentQuestionRubricId))
  if (currentIndex === -1) return computeFirstUnreviewedQuestionRubric(statsPerQuestionRubric)
  const tail = statsPerQuestionRubric.slice(currentIndex + 1)
  const next = tail.find(stat => (stat?.reviewedPercentage ?? 0) < 100)
  return next?.id
}

export const computeFirstUnreviewedSubmission = (submissions = [], { isQuestionScoped = false } = {}) => {
  if (!Array.isArray(submissions) || submissions.length === 0) return null
  if (isQuestionScoped) {
    const unreviewedForQuestion = submissions.find(submission => !submission?.approveStatus)
    return unreviewedForQuestion ? { id: unreviewedForQuestion.id } : null
  }
  const unreviewedSubmission = submissions.find(
    submission =>
      submission?.reviewStatus === SubmissionReviewStatuses.UNREVIEWED ||
      submission?.reviewStatus === SubmissionReviewStatuses.PARTIALLY_REVIEWED,
  )
  return unreviewedSubmission ? { id: unreviewedSubmission.id } : null
}

// Deprecated group-scoped helpers removed in favor of global helpers

export const getAllSubmissionIdsInOrderFromGroups = (groups = []) => {
  return groups?.flatMap(group => group?.submissions?.map(s => s.id) || []) || []
}

export const findFirstEarlierUnapprovedSubmissionId = (groups = [], currentSubmissionId) => {
  if (!currentSubmissionId) return undefined
  const allIds = getAllSubmissionIdsInOrderFromGroups(groups)
  const idx = allIds.indexOf(currentSubmissionId)
  if (idx <= 0) return undefined

  // Build a map id -> submission object to read approveStatus
  const idToSubmission = new Map()
  for (const group of groups || []) {
    for (const s of group?.submissions || []) {
      idToSubmission.set(s.id, s)
    }
  }

  // We want the earliest skipped (first in the list before the current index),
  // not the nearest previous one. Scan from the start up to (but not including) idx.
  for (let i = 0; i < idx; i += 1) {
    const candidateId = allIds[i]
    const sub = idToSubmission.get(candidateId)
    if (sub && !sub?.approveStatus) return candidateId
  }
  return undefined
}

export const getGlobalNextSubmissionIdsFromGroups = (groups = [], currentSubmissionId, take = 3) => {
  if (!currentSubmissionId) return []
  const allIds = getAllSubmissionIdsInOrderFromGroups(groups)
  const idx = allIds.indexOf(currentSubmissionId)
  if (idx === -1) return []
  return allIds.slice(idx + 1, idx + 1 + take)
}

export const getGlobalPreviousSubmissionIdsFromGroups = (groups = [], currentSubmissionId, take = 3) => {
  if (!currentSubmissionId) return []
  const allIds = getAllSubmissionIdsInOrderFromGroups(groups)
  const idx = allIds.indexOf(currentSubmissionId)
  if (idx === -1) return []
  const start = Math.max(0, idx - take)
  return allIds.slice(start, idx).reverse()
}


